import IMask from 'imask';

import dispatchCustomEvent from '../../../utils/dispatch-custom-event';
import Base from '../../base';

import formEvents from './calculator-form-events';
import formOptions from './calculator-form-options';
import PeriodSelector from './calculator-form-period-selector';

class TurboBoosterCalculatorForm extends Base {
	constructor(el) {
		super(el);

		this.isinInput = this.query('[name="isin"]');
		this.amountInput = this.query('[name="amount"]');
		this.underlyingRateInput = this.query('[name="expectedUnderlyingRate"]');
		this.periodSelectorElement = this.query('.js-period-selector');

		this.start();
	}

	get formData() {
		return {
			expectedUnderlyingRate: this.underlyingRateFormatted.unmaskedValue,
			amount: this.amountFormatted.unmaskedValue,
			amountOfDays: this.periodSelector.days,
			isin: this.isinInput.value,
		};
	}

	start() {
		formOptions.set(this.options);

		this.underlyingRateFormatted = new IMask(this.underlyingRateInput, {
			mask: Number,
			scale: formOptions.get('decimalPrecision'),
			thousandsSeparator: formOptions.get('thousandSeparator'),
			radix: formOptions.get('decimalSeparator'),
			padFractionalZeros: true,
			signed: false,
		});

		this.amountFormatted = new IMask(this.amountInput, {
			mask: Number,
			scale: 0,
			thousandsSeparator: formOptions.get('thousandSeparator'),
			signed: false,
			min: 1,
		});

		this.periodSelector = new PeriodSelector(this.periodSelectorElement);

		this.on('submit');
	}

	onSubmit(e) {
		e.preventDefault();

		const { formData } = this;

		dispatchCustomEvent(this.el, formEvents.FORM_SUBMITTED, formData);
	}
}

export default TurboBoosterCalculatorForm;
